import script from "./multi-select.vue?vue&type=script&setup=true&lang=js"
export * from "./multi-select.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__